// src/utils/seoTest.js
/**
 * SEO Validation & Testing Utility for Ankielabs
 * Run this in your browser console to verify 
 * meta tags, schema structure, and social sharing previews.
 */

export function runSeoAudit() {
  console.group("🔍 Ankielabs SEO Diagnostic Audit");

  // 1. Check Title Tag
  const title = document.querySelector("title")?.innerText;
  console.log(`%c[Title Check]:`, "color: #00cbe1; font-weight: bold;", title ? `✅ Found (${title.length} chars): "${title}"` : "❌ Missing <title>");

  // 2. Check Meta Description
  const description = document.querySelector('meta[name="description"]')?.getAttribute("content");
  console.log(`%c[Description Check]:`, "color: #00cbe1; font-weight: bold;", description ? `✅ Found (${description.length} chars): "${description}"` : "❌ Missing meta description");

  // 3. Check Canonical URL
  const canonical = document.querySelector('link[rel="canonical"]')?.getAttribute("href");
  console.log(`%c[Canonical Check]:`, "color: #00cbe1; font-weight: bold;", canonical ? `✅ Valid: ${canonical}` : "❌ Missing canonical link");

  // 4. Check Open Graph Tags (Social Sharing)
  const ogTitle = document.querySelector('meta[property="og:title"]')?.getAttribute("content");
  const ogImage = document.querySelector('meta[property="og:image"]')?.getAttribute("content");
  console.log(`%c[OpenGraph Check]:`, "color: #00cbe1; font-weight: bold;", ogTitle && ogImage ? `✅ OG Tags Active (Image: ${ogImage})` : "❌ Incomplete OG tags");

  // 5. Check Structured Data (JSON-LD)
  const jsonLdScript = document.querySelector('script[type="application/ld+json"]');
  if (jsonLdScript) {
    try {
      const parsedData = JSON.parse(jsonLdScript.innerHTML);
      console.log(`%c[Structured Data (JSON-LD)]:`, "color: #00cbe1; font-weight: bold;", `✅ Valid Schema Type: ${parsedData["@type"]}`, parsedData);
    } catch (e) {
      console.log(`%c[Structured Data (JSON-LD)]:`, "color: #ff4d4d; font-weight: bold;", "❌ Invalid JSON syntax inside script tag");
    }
  } else {
    console.log(`%c[Structured Data (JSON-LD)]:`, "color: #ff4d4d; font-weight: bold;", "❌ Missing JSON-LD schema block");
  }

  console.groupEnd();
}

// Auto-run if in browser environment
if (typeof window !== "undefined") {
  window.runSeoAudit = runSeoAudit;
}